import type { FC } from 'react';
import React from 'react';

import { RoundedIconWrapperContainer } from '@shared/ui/common/RoundedIconWrapper/RoundedIconWrapper.style';

type ConfigItemType = {
  value: string | number;
  icon: React.ComponentType;
  backgroundColor: string;
  borderColor: string;
  iconColor: string;
  [key: string]: any;
};

type RoundedIconWrapperProps<T> = {
  selectedItem: string | number;
  config: { [key: string | number]: T };
  isSmall?: boolean;
  isCanEdit: boolean;
  noneValue?: string | number;
  isBig?: boolean;
  hiddenBackground?: boolean;
  customTagSize?: string;
};

export const RoundedIconWrapper: FC<RoundedIconWrapperProps<ConfigItemType>> = ({
  selectedItem,
  config,
  isCanEdit = true,
  isSmall,
  noneValue,
  isBig,
  hiddenBackground,
  customTagSize,
}) => {
  const item = config[selectedItem];
  return (
    <RoundedIconWrapperContainer
      backgroundColor={item?.backgroundColor}
      borderColor={item?.borderColor}
      iconColor={item?.iconColor}
      itemValue={item?.value}
      noneValue={noneValue}
      isCanEdit={isCanEdit}
      isSmall={isSmall}
      isBig={isBig}
      hiddenBackground={hiddenBackground}
      customTagSize={customTagSize}
    >
      {item && <item.icon />}
    </RoundedIconWrapperContainer>
  );
};
